import useEditorMutation, {
  UseEditorMutationOptions,
} from "../../../hooks/useEditorMutation";
import giftClient, { KlydoGiftProps } from "../../../api/gift";

const useUpsertGiftMutation = (
  options?: UseEditorMutationOptions<void, KlydoGiftProps, void>,
) => {
  return useEditorMutation({
    mutationKey: ["add-gift"],
    mutationFn: (input) => {
      return giftClient.upsertGift(input);
    },
    ...options,
  });
};

export default useUpsertGiftMutation;
